export enum OrderCapacity {
  /** Agency */
  Agency = 'A',
  /** Proprietary */
  Proprietary = 'G',
  /** Individual */
  Individual = 'I',
  Principal = 'P',
  /** Riskless Principal */
  RisklessPrincipal = 'R',
  /** Agent for Other Member */
  AgentForOtherMember = 'W',
  /** Mixed capacity */
  MixedCapacity = 'M',
}
